module.exports = __webpack_public_path__ + "img/image.962bf437.png";